<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h2>{{ 'Legalization.LegalizationDocuments' | translate }}</h2>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="legalization-list-container">
      <div class="document-buttons">
        <button
          [visibleWithPermissions]="['LegalizationDecision', 'AddLegalizationDocument', 'AddBasicLegalizationDocument']"
          mat-raised-button
          color="primary"
          (click)="handleAddDocument(null)"
          >
          {{ 'WL-AddDocument' | translate }}
        </button>
      </div>

      <div class="list-header" >
        <div class="process-header">
          {{ 'Legalization.Register.LegalizationsProcesses' | translate }}
          <div class="process-filter">
            <mat-checkbox class="show-current-only-checkbox"
              [(ngModel)]="showActiveOnly"
              (change)="onShowActiveOnlyChange()">
              {{ 'Legalization.ShowActiveLegalizationsOnly' | translate }}
            </mat-checkbox>
          </div>
        </div>
        <div class="documents-header">{{ 'Legalization.Register.Documents' | translate }}</div>
      </div>
      @if (legalizations && legalizations.length > 0) {
        <table class="legalization-items-table">
          <tbody>
            @for (legalization of legalizations; track legalization) {
              <tr class="legalization-item">
                <td class="process-details">
                  <table class="process-details-table">
                    <thead>
                      <tr>
                        <th>{{ 'Legalization.Register.StartDate' | translate }}</th>
                        <th>{{ 'Legalization.Register.EndDate' | translate }}</th>
                        <th>{{ 'Company' | translate }}</th>
                        <th>{{ 'Employer' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ legalization?.StartDate ? (legalization?.StartDate | date : 'dd.MM.yyyy') : '' }}</td>
                        <td>{{ legalization?.EndDate ? (legalization?.EndDate | date : 'dd.MM.yyyy') : '' }}</td>
                        <td>{{ legalization?.Company }}</td>
                        <td>{{ legalization?.Employer }}</td>
                      </tr>
                    </tbody>
                  </table>
                  @if (legalization?.Status) {
                    <div class="process-status">
                      {{ 'Legalization.LegalizationStatus' | translate }}:
                      <span class="status-label" [ngClass]="legalizationStatusHelper.getStatusClass(legalization?.StatusId)">
                        {{ legalization?.Status }}
                      </span>
                    </div>
                  }
                </td>
                <td class="documents-list">
                  <table mat-table [dataSource]="legalization.Documents" multiTemplateDataRows>
                    <ng-container matColumnDef="expand">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let document">
                        <div class="expand-cell-content">
                          @if (document.DocumentStatusId === LegalizationDocumentStatusEnum.RequiresCorrection) {
                            <div class="correction-button-container"
                              [visibleWithPermissions]="['LegalizationDecision', 'CorrectLegalizationDocumentByCoordinator', 'CorrectLegalizationDocumentByEmployee']"
                              >
                              <button mat-icon-button class="correction-button"
                                [matTooltip]="'Legalization.CorrectDocument' | translate"
                                (click)="handleCorrection(document.Id)">
                                <mat-icon class="correction-icon icon-sm">queue</mat-icon>
                              </button>
                              <span class="correction-label clickable"
                                (click)="handleCorrection(document.Id)"
                                [matTooltip]="'Legalization.CorrectDocument' | translate">
                                {{ 'Legalization.CorrectDocument' | translate }}
                              </span>
                            </div>
                          }
                          @if (document.HasPreviousVersions) {
                            <button mat-icon-button class="expand-button"
                              (click)="toggleDocumentExpansion(document.Id)" [attr.aria-label]="'Toggle previous versions'">
                              <mat-icon [class.expanded]="isDocumentExpanded(document.Id)">
                                {{ isDocumentExpanded(document.Id) ? 'expand_less' : 'expand_more' }}
                              </mat-icon>
                            </button>
                          }
                        </div>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="documentType">
                      <th mat-header-cell *matHeaderCellDef>
                        {{ 'Legalization.DocumentType' | translate }}
                      </th>
                      <td mat-cell *matCellDef="let document">{{ document?.DocumentType	 }}</td>
                    </ng-container>
                    <ng-container matColumnDef="description">
                      <th mat-header-cell *matHeaderCellDef>
                        {{ 'Legalization.Description' | translate }}
                      </th>
                      <td mat-cell *matCellDef="let document">
                        @if (document.Description) {
                          <mat-icon
                            class="material-icons-outlined description-icon"
                            [matTooltip]="document.Description"
                            matTooltipClass="description-tooltip"
                            >info</mat-icon
                            >
                          }
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="startDate">
                        <th mat-header-cell *matHeaderCellDef>
                          {{ 'Legalization.Register.DocumentStartDate' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let document">
                          {{ document?.DocumentStartDate ? (document?.DocumentStartDate | date : 'dd.MM.yyyy') : '' }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="endDate">
                        <th mat-header-cell *matHeaderCellDef>{{ 'Legalization.Register.DocumentEndDate' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let document">
                          {{ document?.DocumentEndDate ? (document?.DocumentEndDate | date : 'dd.MM.yyyy') : '' }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>
                          {{ 'Legalization.StatusName' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let document">
                          <span class="status-label" [ngClass]="legalizationStatusHelper.getDocumentStatusClass(document?.DocumentStatusId)">
                            {{ document?.DocumentStatus }}
                          </span>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>{{ 'Actions' | translate }}</th>
                        <td mat-cell *matCellDef="let document">
                          <div class="actions-container">
                            <div class="action-buttons">
                              <button mat-icon-button [matMenuTriggerFor]="menu" [matTooltip]="'Actions' | translate"
                                #menuTrigger="matMenuTrigger">
                                <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                              </button>
                              <mat-menu #menu="matMenu" panelClass="actions-menu">
                                <ng-container>
                                  @if (document.Files && document.Files.length > 0) {
                                    <button mat-menu-item (click)="openLegalizationFilesModal(document.Files, workerId)"                            >
                                      <mat-icon class="material-icons-outlined">folder_open</mat-icon>
                                      <span>{{ 'Legalization.Register.ShowFiles' | translate }}</span>
                                    </button>
                                  }
                                </ng-container>
                                <ng-container>
                                  @if (document.DocumentStatusId !== LegalizationDocumentStatusEnum.RequiresCorrection) {
                                    <button
                                      [visibleWithPermissions]="['LegalizationDecision', 'AddLegalizationDocument', 'AddBasicLegalizationDocument']"
                                      mat-menu-item
                                      (click)="handleAddDocument(null, legalization.Id)">
                                      <mat-icon class="material-icons-outlined">add_circle</mat-icon>
                                      <span>{{ 'WL-AddDocument' | translate }}</span>
                                    </button>
                                  }
                                </ng-container>
                                <ng-container>
                                  @if (document.DocumentStatusId === LegalizationDocumentStatusEnum.RequiresCorrection) {
                                    <button
                                      [visibleWithPermissions]="['LegalizationDecision', 'CorrectLegalizationDocumentByCoordinator', 'CorrectLegalizationDocumentByEmployee']"
                                      mat-menu-item
                                      (click)="handleCorrection(document.Id)">
                                      <mat-icon class="material-icons-outlined">queue</mat-icon>
                                      <span>{{ 'Legalization.CorrectDocument' | translate }}</span>
                                    </button>
                                  }
                                </ng-container>
                                <ng-container>
                                  <button [visibleWithPermissions]="['AddLegalizationDocument']" mat-menu-item (click)="openAssigningDocuments(workerId, document.Id)">
                                    <mat-icon class="material-icons-outlined">call_split</mat-icon>
                                    <span>{{ 'Legalization.Register.AssignDocument' | translate }}</span>
                                  </button>
                                </ng-container>
                                <ng-container>
                                  <button [visibleWithPermissions]="['EditLegalizationDocument']" mat-menu-item (click)="openEditDocument(document.Id)">
                                    <mat-icon class="material-icons-outlined">edit</mat-icon>
                                    <span>{{ 'Legalization.Register.EditDocument' | translate }}</span>
                                  </button>
                                </ng-container>
                              </mat-menu>
                            </div>
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="expandedDetail">
                        <td mat-cell *matCellDef="let document" [attr.colspan]="documentsDisplayedColumns.length" class="expanded-detail-cell">
                          <div class="expanded-element-detail" [@detailExpand]="isDocumentExpanded(document.Id) ? 'expanded' : 'collapsed'">
                            <table mat-table [dataSource]="document.PreviousVersionsEntites" class="previous-versions-table">
                              <ng-container matColumnDef="expand">
                                <td mat-cell *matCellDef="let row">
                                  <span class="previous-version-indicator">↳</span>
                                </td>
                              </ng-container>
                              <ng-container matColumnDef="documentType">
                                <td mat-cell *matCellDef="let row">{{ row?.DocumentType }}</td>
                              </ng-container>
                              <ng-container matColumnDef="description">
                                <td mat-cell *matCellDef="let row">
                                  @if (row.Description) {
                                    <mat-icon
                                      class="material-icons-outlined description-icon"
                                      [matTooltip]="row.Description"
                                      matTooltipClass="description-tooltip"
                                      >info</mat-icon
                                      >
                                    }
                                  </td>
                                </ng-container>
                                <ng-container matColumnDef="startDate">
                                  <td mat-cell *matCellDef="let row">
                                    {{ row?.DocumentStartDate ? (row?.DocumentStartDate | date : 'dd.MM.yyyy') : '' }}
                                  </td>
                                </ng-container>
                                <ng-container matColumnDef="endDate">
                                  <td mat-cell *matCellDef="let row">
                                    {{ row?.DocumentEndDate ? (row?.DocumentEndDate | date : 'dd.MM.yyyy') : '' }}
                                  </td>
                                </ng-container>
                                <ng-container matColumnDef="status">
                                  <td mat-cell *matCellDef="let row">
                                    <span class="status-label" [ngClass]="legalizationStatusHelper.getDocumentStatusClass(row?.DocumentStatusId)">
                                      {{ row?.DocumentStatus }}
                                    </span>
                                  </td>
                                </ng-container>
                                <ng-container matColumnDef="actions">
                                  <td mat-cell *matCellDef="let row">
                                    <div class="actions-container">
                                      <div class="action-buttons">
                                        <button mat-icon-button [matMenuTriggerFor]="prevMenu"
                                          [matTooltip]="'Actions' | translate" #prevMenuTrigger="matMenuTrigger">
                                          <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                                        </button>
                                        <mat-menu #prevMenu="matMenu" panelClass="actions-menu">
                                          @if (row.Files && row.Files.length > 0) {
                                            <button mat-menu-item (click)="openLegalizationFilesModal(row.Files, workerId)"
                                              >
                                              <mat-icon class="material-icons-outlined">folder_open</mat-icon>
                                              <span>{{ 'Legalization.Register.ShowFiles' | translate }}</span>
                                            </button>
                                          }
                                        </mat-menu>
                                      </div>
                                    </div>
                                  </td>
                                </ng-container>
                                <tr mat-row *matRowDef="let row; columns: previousVersionsDisplayedColumns;"
                                class="document-row previous-version"></tr>
                              </table>
                            </div>
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="documentsDisplayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: documentsDisplayedColumns;" class="document-row"></tr>
                        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']; when: hasPreviousVersions"
                        class="detail-row"></tr>
                        <tr class="mat-row" *matNoDataRow>
                          <td class="mat-cell" [attr.colspan]="documentsDisplayedColumns.length - 1"></td>
                          <td class="mat-cell">
                            <div class="actions-container">
                              <div class="action-buttons">
                                <button mat-icon-button [matMenuTriggerFor]="emptyMenu" [matTooltip]="'Actions' | translate">
                                  <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                                </button>
                                <mat-menu #emptyMenu="matMenu" panelClass="actions-menu">
                                  <ng-container>
                                    <button [visibleWithPermissions]="['LegalizationDecision', 'AddLegalizationDocument', 'AddBasicLegalizationDocument']"
                                      mat-menu-item
                                      (click)="handleAddDocument(null, legalization.Id)">
                                      <mat-icon class="material-icons-outlined">add_circle</mat-icon>
                                      <span>{{ 'WL-AddDocument' | translate }}</span>
                                    </button>
                                  </ng-container>
                                </mat-menu>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
      </mat-expansion-panel>
    </mat-accordion>